import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import styled from "styled-components";
import { useNavigate } from 'react-router-dom';
import DiscountCouponService from "../../pages/DiscountCoupon/Discountcoupons.service";
import AuthService from "../../pages/Authentication/auth.service";
import Alerts from "../../components/Alerts/alerts";
import PermissionAccess from '../../PermissionAccess/Access.js';

const Input = styled.input.attrs(props => ({
  type: "text",
  size: props.small ? 5 : undefined
}))`
  height: 32px;
  width: 200px;
  border-radius: 3px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border: 1px solid var(--buttons-color, #30b1ff);
  padding: 0 32px 0 16px;
  justify-content: flex-start;
`;

const Select = styled.select`
  height: 32px;
  width: 200px;
  border-radius: 3px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border: 1px solid var(--buttons-color, #30b1ff);
  margin-left: 10px;
  padding: 0 16px;
`;

const Button = styled.button`
  margin-left: 2%;
  type: button;
  class: btn btn-custom-color btn-hover-shine me-3 btn;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const DiscountCouponsFilter = ({ onClear, onSearch }) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [status, setStatus] = useState("");
  const [businesses, setBusinesses] = useState([]);
  const { authData, accessPages, super_admin, current_module } = PermissionAccess();

 
  const handleClear = () => {
    onClear();
    setStatus('');
  };

  const handleSearch = () => {
    onSearch(status);
  };



  function fetchBusinesses() {
  
      const stored_user = authData.userData;
      let business = []
      if (stored_user.businesses) {
        business = stored_user.businesses
      }
  
      DiscountCouponService.getAllDoctors(authData.sessionID,0, 9999999, '', '', '').then(
        (response) => {
  
          if (response.data.message === "Unauthorized") {
            AuthService.logout();
            navigate("/login");
            window.location.reload();
          } else {
            setBusinesses(response.data.data);
          }
        },
        (error) => {
  
          const errContent =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();
          if (errContent) {
            Alerts.swalErrorAlert(errContent);
          } else {
            Alerts.swalErrorAlert(t("Server Error, Please try again later."));
          }
        }
      );
    }
  
    useEffect(() => {
      fetchBusinesses();
    }, []);

  

  return (
    <Container>
      
      <Select
        value={status}
        onChange={(e) => setStatus(e.target.value)}
      >
        <option value="">{t('Select Status')}</option>
        <option value="Paid">{t('Paid')}</option>
        <option value="Rejected">{t('Rejected')}</option>
      </Select>

      <Button className="btn btn-custom-color btn-hover-shine me-3 btn"
        onClick={handleSearch}
      >
        {t('Search')}
      </Button>
      <Button className="btn btn-custom-color btn-hover-shine me-3 btn"
        onClick={handleClear}
      >
        {t('Reset')}
      </Button>
    </Container>
  );
};

export default DiscountCouponsFilter;
